var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
    !_vm.isAdd
      ? _c(
          "div",
          [
            _c(
              "el-card",
              { attrs: { header: "投保须知" } },
              [
                _c(
                  "el-container",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.isLoadingPdf,
                        expression: "isLoadingPdf",
                      },
                    ],
                    ref: "pdf",
                    style: _vm.setHeight,
                  },
                  [
                    _c(
                      "el-main",
                      {
                        staticClass: "pdf-content",
                        style: !_vm.isCanScroll ? { overflow: "hidden" } : {},
                      },
                      [
                        _c(
                          "el-alert",
                          {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: { closable: false, type: "error" },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "1.25em",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t为保障您的合法权益，请您仔细阅读以下各部分内容，重要内容将以红色加粗字体为您标记，请务必知晓。如有疑问，请先联系客服人员确认无误后再行投保。\n\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm.protocolInfoData.declareContent !== ""
                          ? _c("div", { staticClass: "center_info_content" }, [
                              _vm.currentPosition === -1
                                ? _c("div", {
                                    staticClass: "u-m-b-20",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.protocolInfoData.declareContent
                                      ),
                                    },
                                  })
                                : _vm._e(),
                              _vm.isShowPdf
                                ? _c("div", [
                                    _vm.currentPosition >= 0 &&
                                    _vm.currentPdfPages > 0
                                      ? _c(
                                          "div",
                                          _vm._l(
                                            _vm.visiblePages,
                                            function (index) {
                                              return _c("pdf", {
                                                key:
                                                  _vm.currentPosition +
                                                  "-" +
                                                  index,
                                                staticStyle: {
                                                  "margin-left": "200px",
                                                  "margin-right": "200px",
                                                },
                                                attrs: {
                                                  page: index,
                                                  src: _vm.currentPdfSrc,
                                                },
                                                on: {
                                                  progress: _vm.onPdfProcess,
                                                  error: _vm.onPdfError,
                                                  "page-loaded":
                                                    _vm.onOverReload,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.currentPdfPages > 0 ||
                                    _vm.currentPosition === -1
                                      ? _c("div", { staticClass: "u-m-b-20" }, [
                                          _c(
                                            "div",
                                            { staticClass: "customPage" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentPosition + 2
                                                ) +
                                                  "/" +
                                                  _vm._s(_vm.pdfPath.length + 1)
                                              ),
                                            ]
                                          ),
                                          !_vm.isHideBtn
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "center",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.currentPosition ===
                                                          -1,
                                                        plain: "",
                                                        type: "default",
                                                      },
                                                      on: {
                                                        click: _vm.onPageLast,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t上一页\n\t\t\t\t\t\t\t\t\t"
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.currentNum > 0,
                                                        type: "primary",
                                                      },
                                                      on: {
                                                        click: _vm.onPageNext,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.currentNum > 0
                                                              ? _vm.currentNum +
                                                                  "s后可关闭"
                                                              : "我已逐条阅读并同意"
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            !_vm.isShowPdf
              ? _c(
                  "div",
                  [
                    _vm.protocolInfoData.clauseFileUrls || []
                      ? _c(
                          "el-card",
                          {
                            staticClass: "u-m-t-20",
                            attrs: { header: "保险条款" },
                          },
                          _vm._l(
                            _vm.protocolInfoData.clauseFileUrls,
                            function (itemData, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "link" },
                                [
                                  _c(
                                    "el-link",
                                    {
                                      attrs: {
                                        href: itemData.url,
                                        target: "_blank",
                                        type: "primary",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(
                                            itemData.name.replace(".pdf", "")
                                          ) +
                                          "\n\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                  _c("br"),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                    _vm.protocolInfoData.delegateFileUrls
                      ? _c(
                          "el-card",
                          {
                            staticClass: "u-m-t-20",
                            attrs: { header: "保险经纪服务委托协议" },
                          },
                          _vm._l(
                            _vm.protocolInfoData.delegateFileUrls,
                            function (itemData, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "link" },
                                [
                                  _c(
                                    "el-link",
                                    {
                                      attrs: {
                                        href: itemData.url,
                                        target: "_blank",
                                        type: "primary",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(
                                            itemData.name.replace(".pdf", "")
                                          ) +
                                          "\n\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                  _c("br"),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                    _vm.protocolInfoData.webServiceFileUrl
                      ? _c(
                          "el-card",
                          {
                            staticClass: "u-m-t-20",
                            attrs: { header: "网站服务协议" },
                          },
                          _vm._l(
                            _vm.protocolInfoData.webServiceFileUrl,
                            function (itemData, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "link" },
                                [
                                  _c(
                                    "el-link",
                                    {
                                      attrs: {
                                        href: itemData.url,
                                        target: "_blank",
                                        type: "primary",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(
                                            itemData.name.replace(".pdf", "")
                                          ) +
                                          "\n\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                  _c("br"),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm.isHideBtn || !_vm.isShowPdf
              ? _c(
                  "el-card",
                  { staticClass: "u-m-t-20", attrs: { header: "投保人声明" } },
                  [
                    _c(
                      "el-alert",
                      {
                        staticClass: "u-m-b-10",
                        attrs: { closable: false, type: "error" },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "u-font-weight-bold u-font-14" },
                          [_vm._v("为保障您的合法权益，请您仔细阅读后勾选确认")]
                        ),
                      ]
                    ),
                    _vm.protocolInfoData.declares || []
                      ? _c(
                          "el-row",
                          { attrs: { justify: "start", type: "flex" } },
                          [
                            _c(
                              "el-checkbox-group",
                              {
                                model: {
                                  value: _vm.checkListStatement,
                                  callback: function ($$v) {
                                    _vm.checkListStatement = $$v
                                  },
                                  expression: "checkListStatement",
                                },
                              },
                              _vm._l(
                                _vm.protocolInfoData.declares,
                                function (ref) {
                                  var content = ref.content
                                  if (content === void 0) content = ""
                                  return _c("el-checkbox", {
                                    key: content,
                                    staticClass: "u-m-b-10",
                                    attrs: { label: content },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-row",
                      {
                        staticStyle: { "margin-top": "5px" },
                        attrs: { justify: "center", type: "flex" },
                      },
                      [
                        _c("el-tag", { attrs: { type: "" } }, [
                          _c(
                            "span",
                            { staticClass: "u-font-weight-bold u-font-14" },
                            [_vm._v("请滑动鼠标至底部，阅读并确认全部内容")]
                          ),
                        ]),
                        _c("p"),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { justify: "center", type: "flex" } },
                      [
                        _vm.isShowPdf
                          ? _c(
                              "el-button",
                              {
                                attrs: { plain: "", type: "primary" },
                                on: { click: _vm.onBackInsured },
                              },
                              [_vm._v("查看投保须知")]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: !_vm.onSureAble,
                              type: "primary",
                            },
                            on: { click: _vm.onStepConfirm },
                          },
                          [_vm._v("我已逐条阅读并同意投保")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "u-flex u-row-center u-m-t-20" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onStepConfirm } },
              [_vm._v("同意投保")]
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }